import { render, staticRenderFns } from "./TheTextbausteinConfirm.vue?vue&type=template&id=2df32a30&scoped=true"
import script from "./TheTextbausteinConfirm.vue?vue&type=script&lang=js"
export * from "./TheTextbausteinConfirm.vue?vue&type=script&lang=js"
import style0 from "./TheTextbausteinConfirm.vue?vue&type=style&index=0&id=2df32a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df32a30",
  null
  
)

export default component.exports